const GA_ID = 'G-JZDEC6BHCW';
export const CONSENT_KEY = 'biolosophy_cookie_consent';

export const getConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveConsent = (analytics) => {
  localStorage.setItem(
    CONSENT_KEY,
    JSON.stringify({ necessary: true, analytics, date: new Date().toISOString() })
  );
  if (analytics) loadGoogleAnalytics();
};

export const loadGoogleAnalytics = () => {
  if (window.__gaLoaded) return;
  window.__gaLoaded = true;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { anonymize_ip: true });
};
